import { Layout } from "@certn/cascadia-react";
import { CascadiaColor } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";
import { PropsWithChildren, ReactNode } from "react";

import { LeverIntegrationStepHeader } from "./LeverIntegrationStepHeader";

interface Props extends PropsWithChildren {
  disableCompletion?: boolean;
  submitting?: boolean;
  onComplete?: () => void;
  contentHeader?: ReactNode;
  rightSideBar?: ReactNode;
  backgroundColor?: CascadiaColor | false;
}

export function LeverIntegrationStepLayout(props: Props) {
  const {
    disableCompletion,
    submitting,
    onComplete,
    contentHeader,
    rightSideBar,
    backgroundColor = "surface-base",
    children,
  } = props;

  return (
    <Layout
      layout="narrow"
      backgroundColor={backgroundColor}
      header={
        <LeverIntegrationStepHeader
          onComplete={onComplete}
          isDisabled={disableCompletion}
          submitting={submitting}
        />
      }
      contentHeader={contentHeader}
      rightSideBar={rightSideBar}
    >
      <div className={styles.container}>{children}</div>
    </Layout>
  );
}

const styles = {
  container: css({
    display: "flex",
    justifyContent: "center",
  }),
};
